import React from 'react';
import NavigationBar from '../navbar/NavigationBar';
import Footer from '../navbar/Footer';
import { Container, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

const publications = [
  {
    title: "Indice des Prix à la Consommation (Taux d'inflation)",
    date: "15 de chaque mois",
    description: "Indicateur mesurant l'évolution du prix des biens de consommation pour évaluer l'inflation."
  },
  {
    title: "Bulletins Mensuels des Prix",
    date: "15 de chaque mois",
    description: "Rapport mensuel sur l'évolution des prix de divers produits sur le marché."
  },
  {
    title: "Indice des Prix à la Production Agricole",
    date: "15 de chaque mois",
    description: "Mesure des prix reçus par les producteurs agricoles pour leurs produits."
  },
  {
    title: "Indice du Coût de Construction de Logements Neufs au Burundi (ICCLB)",
    date: "15 de chaque mois",
    description: "Suivi des coûts associés à la construction de nouveaux logements."
  },
];

function PublicationsMensuel() {
  return (
    <div style={{ backgroundColor: '#f5f5f5', paddingBottom: '40px' }}>
      <NavigationBar />
      
       <Container maxWidth="lg" style={{ paddingTop: '54px' }}>


        <Typography variant="h4" align="justify" gutterBottom style={{ color: '#388E3C' }}>
          Calendrier de diffusion pour les publications mensuelles
        </Typography>

        <Typography variant="body1" align="justify" paragraph style={{ fontSize: '1.1rem', color: '#333' }}>
          Les publications suivantes sont diffusées le 15 de chaque mois. Elles fournissent des informations importantes sur l'économie du Burundi.
        </Typography>

        <TableContainer component={Paper} style={{ marginTop: '20px' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontWeight: 'bold' }}>N°</TableCell>
                <TableCell style={{ fontWeight: 'bold'}}>Titre</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Description</TableCell>
                <TableCell style={{ fontWeight: 'bold' }}>Date de diffusion</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {publications.map((pub, index) => (
                <TableRow key={index}>
                  <TableCell>{index + 1}</TableCell> {/* Affichage du numéro d'ordre */}
                  <TableCell>{pub.title}</TableCell>
                  <TableCell>{pub.description}</TableCell>
                  <TableCell>{pub.date}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

      </Container>
      <br />
        <br />
      <Footer />
    </div>
  );
}

export default PublicationsMensuel;